import { render, staticRenderFns } from "./lk-date.vue?vue&type=template&id=44c3053d&"
import script from "./lk-date.vue?vue&type=script&lang=js&"
export * from "./lk-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-date/lk-date.vue
// module id = 143
// module chunks = 0